import { Box, Button, Radio, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { WALLET_TYPE } from '../model';
const SelectWalletType = (props) => {
    const [selectedWalletType, setSelectedWalletType] = useState();
    const handleChange = (value) => {
        setSelectedWalletType(value);
    };
    useEffect(() => {
        if (selectedWalletType) {
            props.onWalletTypeChange(selectedWalletType);
        }
    }, [selectedWalletType]);
    return (React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 2 } },
        React.createElement(Typography, { variant: 'subtitle2', fontWeight: 'bold' }, "Select Wallet Type"),
        React.createElement(Typography, { variant: 'caption' }, "Please select the type of wallet the deposit was sent from:"),
        React.createElement(Box, null,
            React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 2 } },
                React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', border: '1px solid', borderRadius: 1, p: 2 }, onClick: () => {
                        handleChange(WALLET_TYPE.SELF_HOSTED);
                    } },
                    React.createElement(Radio, { value: 'self-hosted', checked: selectedWalletType === WALLET_TYPE.SELF_HOSTED }),
                    React.createElement(Box, null,
                        React.createElement(Typography, null, "Self-Hosted Wallet"),
                        React.createElement(Typography, { variant: 'caption' }, "The deposit came from a personal, non-custodial wallet"))),
                React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', border: '1px solid', borderRadius: 1, p: 2 }, onClick: () => {
                        handleChange(WALLET_TYPE.VASP_HOSTED);
                    } },
                    React.createElement(Radio, { value: 'vasp', checked: selectedWalletType === WALLET_TYPE.VASP_HOSTED }),
                    React.createElement(Box, null,
                        React.createElement(Typography, null, "VASP-Hosted Wallet"),
                        React.createElement(Typography, { variant: 'caption' }, `The deposit came from a Virtual Asset Service Provider (e.g., Exchange, Custody Provider)`))))),
        React.createElement(Button, { variant: 'contained', disabled: !selectedWalletType, onClick: () => {
                props.onNext('self-hosted');
            } }, "Continue"),
        React.createElement(Button, { variant: 'outlined', onClick: () => {
                props.onClose();
            } }, "Cancel")));
};
export default SelectWalletType;
